var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#search_svg__clip0_1161_50117)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.082 5.686a5.228 5.228 0 1 1-7.394 7.394 5.228 5.228 0 0 1 7.394-7.394m-9.744-2.35a8.55 8.55 0 0 0 0 12.093 8.55 8.55 0 0 0 10.871 1.007l2.23 2.228c1.505 1.507 3.734-.72 2.227-2.228l-2.228-2.229a8.55 8.55 0 0 0-1.007-10.87 8.55 8.55 0 0 0-12.093 0"
}))));
export default SvgSearch;